import {
  INTERSECT_EFFECT,
  IntersectHandler,
} from "../components/intersect-handler";

const SELECTORS = {
  component: ".js-node-content .js-field-content",
};

window.Drupal.behaviors.app_intersect_fade_in = {
  attach: (context, settings) => {
    const components = [...context.querySelectorAll(SELECTORS.component)];

    for (const component of components) {
      const instance = new IntersectHandler(component);

      instance
        .setEffect(INTERSECT_EFFECT.fadeIn, {
          once: true,
          defer: true,
        })
        .init();
    }
  },
};
